import { TableBody as MuiTableBody, type TableBodyProps as MuiTableBodyProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiTableBodyProps>;

export function TableBody(props: Props) {
  return <MuiTableBody {...props} />;
}

export type { Props as TableBodyProps };
